export default ({ res, query }, inject) => {
    // Query string to activate secondary timings
    const { enableTiming } = query

    // Start the timer with a specific name
    const start = (name) => {
        if (!process.server || !enableTiming) return

        res.timing.start(name, '')
    }

    // End the timer by the name
    const end = (name) => {
        if (!process.server || !enableTiming) return

        res.timing.end(name)
    }

    inject('timing', {
        start,
        end,
    })
}
